// src/axiosConfig.js
import axios from 'axios';

const instance = axios.create({
  baseURL: '/api',
});

instance.interceptors.request.use((config) => {
  const isFormData = typeof FormData !== 'undefined' && config.data instanceof FormData;
  const headers = config.headers;

  if (!headers) return config;

  const unsetContentType = () => {
    if (typeof headers.delete === 'function') {
      headers.delete('Content-Type');
      headers.delete('content-type');
    } else {
      delete headers['Content-Type'];
      delete headers['content-type'];
    }
  };

  if (isFormData) {
    unsetContentType();
  } else if (config.data !== undefined && config.data !== null) {
    const hasType = typeof headers.get === 'function'
      ? headers.get('Content-Type')
      : headers['Content-Type'] || headers['content-type'];
    if (!hasType) {
      if (typeof headers.set === 'function') {
        headers.set('Content-Type', 'application/json');
      } else {
        headers['Content-Type'] = 'application/json';
      }
    }
  }

  return config;
});

export default instance;
